<template>
	<div>
		<v-dialog v-model="dialog_unit_groups" no-click-animation persistent scrollable content-class="full-height" lazy>
        	<v-card>
        		<v-subheader full-width class="pr-0">{{$parent.Form.itemName}}
        			<v-spacer></v-spacer>
        			<!-- <v-btn color="primary" small flat justify-content-to-end nomargin :ripple="false" @click="addMore(true)">New</v-btn> -->
        			<v-btn flat icon @click="addMore(true)">
        				<v-icon class="primary-color">add</v-icon>
        			</v-btn>
        		</v-subheader>
        		<v-divider></v-divider>
        	  	<v-card-text full-height nopadding>
        	  		<!-- {{tpGroups}} -->
        	  		<v-data-table
					    :headers="headers"
					    :items="tpGroups"
					    class="elevation-0"
					    hide-actions
					  >
					    <template slot="items" slot-scope="props">
					    	<tr @click="appendSection(props.item)">
					    		<td>&#8377;{{ props.item.mrp }}</td>
							    <td>&#8377;{{ props.item.rate }}</td>
							    <td class="text-xs-right">
							    	<span v-for="(vItem, index) in props.item.variants" :key="index">{{vItem.unitName}} 						{{vItem.qty ? vItem.qty : 0}}{{props.item.variants.length-1 != index ? ', ' : ''}}
							    	</span>
							    </td>
					    	</tr>
					      
					    </template>
					  </v-data-table>
        	  		</v-list>
        	  			
        	  	</v-card-text>
        	  	<v-divider></v-divider>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog()">close</v-btn>
		        </v-card-actions>
	        	</v-card>	
      	</v-dialog>
	</div>
</template>	 	

<script>
export default{
	props:['tpGroups', 'appendSection', 'addMore'],
	data(){	
		return{
			dialog_unit_groups: false,
			headers: [
	          { text: 'MRP', sortable: false, value: 'MRP', align: 'left' },
	          { text: 'Rate', sortable: false, value: 'Rate', align: 'left' },
	          { text: 'Stock', sortable: false, value: 'Stock', align: 'right' },
	        ]
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.dialog_unit_groups = true;
		},
		closeDialogWeb: function () {
			this.dialog_unit_groups = false;
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/stock_journal/dialogs/dialog_unit_groups.vue